import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as WorkerVerificationActions from './worker-verification.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class WorkerVerificationStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new WorkerVerificationActions.WorkerVerificationRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.WORKERVERIFICATION, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new WorkerVerificationActions.WorkerVerificationCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new WorkerVerificationActions.WorkerVerificationUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new WorkerVerificationActions.WorkerVerificationDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new WorkerVerificationActions.WorkerVerificationRefresh());
      }
    });

  }
}
